<template>
  <div>
    <div class="mycontainer" style="margin-bottom: 0px">
      <el-form :model="judgesInfo" :inline="true">
        <el-form-item label="课题属性" label-width="80px">
          <el-select
            v-model="judgesInfo.courseGroup"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in courseGroupList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="部门" label-width="50px">
          <el-select
            ref="txlx"
            v-model="judgesInfo.workUnit"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="item in deptUser"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmmc"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="姓名" prop="name" label-width="50px">
          <el-input
            v-model="judgesInfo.judges"
            size="small"
            style="width: 150px"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="角色" label-width="50px">
          <el-select
            ref="sun"
            v-model="judgesInfo.judgesType"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 120px"
            class="filter-item"
          >
            <el-option value="1" label="评委"></el-option>
            <el-option value="2" label="导师"></el-option>
          </el-select>
        </el-form-item>
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList()"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="handleAdd()"
            style="margin-left: 15px"
            >新增</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <el-table
        :data="judgesList"
        fit
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
        :max-height="height"
      >
        <el-table-column
          label="操作"
          align="center"
          min-width="120px"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="text"
              @click="handleDelete(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          label="课题属性"
          align="center"
          prop="courseGroupName"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="姓名"
          align="center"
          prop="judges"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="角色类型"
          align="center"
          prop="judgesTypeName"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="部门"
          align="center"
          prop="workUnit"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="职位"
          align="center"
          prop="post"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="有效开始时间"
          align="center"
          prop="startTime"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="有效结束时间"
          align="center"
          prop="endTime"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <add v-if="openDialog" ref="testDialog"></add>
    <edit v-if="openDialogEdit" ref="testDialogEdit"></edit>
  </div>
</template>

<script>
import { deletejudges, list, judgesAdd, editJudges } from "@/api/judges.js";
import { getDict } from "@/api/common";
import add from "./add.vue";
import edit from "./edit.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    add,
    edit,
  },
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      judgesInfo: {},
      judgesList: [],
      openDialog: false,
      openDialogEdit: false,
      courseGroupList: [],
      height: 0,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    getDict("pmp_course_group", "1").then((res) => {
      if (res.code == 0) {
        this.courseGroupList = res.data;
      }
    });
    this.getList();
  },
  methods: {
    getList() {
      list(this.judgesInfo, this.page, this.pageSize).then((res) => {
        if (res.code == 0) {
          this.judgesList = res.data;
          this.total = res.count;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 150;
          document.querySelector(".project-select").style.maxHeight =
            docH - 52 + "px";
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleAdd() {
      this.openDialog = true;
      this.$nextTick(() => {
        this.$refs.testDialog.init();
      });
    },
    handleEdit(judgesInfo) {
      this.openDialogEdit = true;
      this.$nextTick(() => {
        this.$refs.testDialogEdit.init(judgesInfo);
      });
    },
    handleDelete(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return deletejudges(id);
        })
        .then((res) => {
          if (res.code == 0) {
            this.getList();
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$notify({
              title: "失败",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
        })
        .catch(() => {});
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
  },
};
</script>

<style>
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
</style>